import { render } from "./dbs.vue?vue&type=template&id=6a7de970"
import script from "./dbs.vue?vue&type=script&lang=js"
export * from "./dbs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__